import axios from "axios";
import * as Sentry from "@sentry/react";
import { toast } from "react-toastify";

const MAX_RETRIES = 2;

const api = axios.create();

/**
 * Verifica si el usuario tiene conexión a Internet antes de hacer la petición.
 */
const isOnline = () => navigator.onLine;

/**
 * Reintenta la petición si el backend devuelve un timeout.
 */
const retryRequest = async (url, options) => {
  let attempt = 0;

  while (attempt < MAX_RETRIES) {
    try {
      console.log(`🔄 Intento ${attempt + 1} de ${MAX_RETRIES}`);
      return await request(url, options, false);
    } catch (error) {
      attempt++;
      
      // Si el backend no devolvió un timeout, no reintentar
      if (!error.response || error.response.status !== 504) {
        throw error;
      }

      // Último intento fallido, lanzar el error
      if (attempt === MAX_RETRIES) {
        throw error;
      }

      console.warn(`⚠️ Reintentando (${attempt}/${MAX_RETRIES}) en 2 segundos...`);
      await new Promise((res) => setTimeout(res, 2000));
    }
  }
};


let isShowingError = false;

const request = async (url, options = {}, allowRetry = true) => {
  if (!isOnline()) {
    if (!isShowingError) {
      isShowingError = true;
      toast.warning("⚠️ No tienes conexión a internet.");
      setTimeout(() => (isShowingError = false), 5000);
    }
    return { error: "Sin conexión a internet" };
  }

  try {
    const response = await api({
      url,
      method: options.method || "GET",
      data: options.body ? JSON.parse(options.body) : null,
      headers: options.headers || {},
    });

    return response.data;
  } catch (error) {
    
    // Si el backend devuelve timeout (504), reintentar
    if (allowRetry && error.response?.status === 504) {
      return retryRequest(url, options);
    }

    if (error.response) {
      if (!isShowingError) {
        isShowingError = true;

        setTimeout(() => (isShowingError = false), 10000);
      }
    }
  }
};

export default request;
